import {
    allFetch,
    ResultObj
} from "../Domain";

/**
 *  @description 從訂單查詢潛客(參數)
 */

export interface PotentialCustomerSearchFromOrderParams {
    potential_customer_name: string;
    source: string;
    level: string;
    cellphone: string;
    page: number;
    num_per_page: number;
}

/**
 *  @description 從訂單查詢潛客(回傳)
 */
export interface PotentialCustomerSearchFromOrderResItem {
    cellphone: string;
    chance_number: string;
    cre_time: string;
    level: string;
    level_name: string;
    potential_customer_id: string;
    potential_customer_name: string;
    source: string;
    source_name: string;
    address_contact: string
}

export const PotentialCustomerSearchFromOrder =
    async (obj: PotentialCustomerSearchFromOrderParams = {
        potential_customer_name: '',
        source: '',
        level: '',
        cellphone: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<PotentialCustomerSearchFromOrderResItem[]>> => await allFetch('PotentialCustomer/PotentialCustomerSearchFromOrder', obj);



/** @description 從訂單查詢潛客細項(參數) */

export interface PotentialCustomerDetailFromOrderParams {
    potential_customer_id: string;
}

/** @description 從訂單查詢潛客細項(回傳) */
export interface PotentialCustomerDetailFromOrderResItem {
    address_contact: string;
    birthday: string;
    cellphone: string;
    chance_number: string;
    cre_time: string;
    email: string;
    identity_number: string;
    level: string;
    potential_customer_id: string;
    potential_customer_name: string;
    source: string;
}

/** @description 從訂單查詢潛客細項(參數)*/
export const PotentialCustomerDetailFromOrder =
    async (obj: PotentialCustomerDetailFromOrderParams = {
        potential_customer_id: ''
    }): Promise<ResultObj<PotentialCustomerDetailFromOrderResItem[]>> => await allFetch('PotentialCustomer/PotentialCustomerDetailFromOrder', obj);

/**
 *  @description 從訂單新增潛客(參數)
 */

export interface PotentialCustomerCreateFromOrderParams {
    potential_customer_name: string;
    source: string;
    level: string;
    cellphone: string;
    address_contact: string;
    chance_number: string;
    email: string;
    identity_number: string;
    birthday: string;
}

/**
 *  @description 從訂單新增潛客(回傳)
 *  @param potential_customer_id 潛客流水號
 */
export interface PotentialCustomerCreateFromOrderResItem {
    potential_customer_id: string;

}

export const PotentialCustomerCreateFromOrder =
    async (obj: PotentialCustomerCreateFromOrderParams = {
        potential_customer_name: '',
        source: '',
        level: '',
        cellphone: '',
        address_contact: '',
        chance_number: '',
        email: '',
        identity_number: '',
        birthday: '',
    }): Promise<ResultObj<PotentialCustomerCreateFromOrderResItem[]>> => await allFetch('PotentialCustomer/PotentialCustomerCreateFromOrder', obj);

/**
*  @description 訂單潛客資訊修改區(參數) 
*/
export interface PotentialCustomerUpdateFromOrderParams {
    potential_customer_name: string,
    chance_number: string,
    source: string,
    level: string,
    cellphone: string,
    address_contact: string,
    identity_number: string,
    birthday: string,
    email: string,
    potential_is_orderer: string,
    potential_customer_id: string,
    orderer_customer_name: string,
    orderer_identity_number: string,
    orderer_cellphone: string,
    orderer_address_contact: string,
    orderer_birthday: string,
    orderer_email: string,
}

export const PotentialCustomerUpdateFromOrder =
    async (obj: PotentialCustomerUpdateFromOrderParams = {
        potential_customer_name: '',
        source: '',
        level: '',
        cellphone: '',
        address_contact: '',
        identity_number: '',
        birthday: '',
        email: '',
        potential_is_orderer: '',
        potential_customer_id: '',
        orderer_customer_name: '',
        orderer_identity_number: '',
        orderer_cellphone: '',
        orderer_address_contact: '',
        orderer_birthday: '',
        orderer_email: '',
        chance_number: '',
    }): Promise<ResultObj> => await allFetch('PotentialCustomer/PotentialCustomerUpdateFromOrder', obj);














// -----------------------------------------------------
/**
*  @description 潛客查詢(參數)
*/

export interface PotentialCustomerSearchParams {
    potential_customer_name: string;
    source: string;
    level: string;
    cellphone: string;
    page: number,
    num_per_page: number
}

/**
 *  @description 潛客查詢(回傳)
 *  @param potential_customer_id 潛客流水號
 */
export interface PotentialCustomerSearchResItem {
    cellphone: string;
    chance_number: string;
    cre_time: string;
    level: string;
    level_name: string;
    potential_customer_id: string;
    potential_customer_name: string;
    source: string;
    source_name: string;

}

export const PotentialCustomerSearch =
    async (obj: PotentialCustomerSearchParams = {
        potential_customer_name: '',
        source: '',
        level: '',
        cellphone: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<PotentialCustomerSearchResItem[]>> => await allFetch('PotentialCustomer/PotentialCustomerSearch', obj);


/**
*  @description 潛客細項(參數)
*/

export interface PotentialCustomerDetailParams {
    potential_customer_id: string;
}

/**
 *  @description 潛客細項(回傳)
 */
export interface PotentialCustomerDetailResItem {
    address_contact: string;
    birthday: string;
    cellphone: string;
    chance_number: string;
    cre_time: string;
    email: string;
    identity_number: string;
    level: string;
    potential_customer_id: string;
    potential_customer_name: string;
    source: string;

}

export const PotentialCustomerDetail =
    async (obj: PotentialCustomerDetailParams = {
        potential_customer_id: '',
    }): Promise<ResultObj<PotentialCustomerDetailResItem[]>> => await allFetch('PotentialCustomer/PotentialCustomerDetail', obj);